"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { InputHelperText } from "../../../building-blocks/inputs/InputHelperText.js";
import "../../../utilities/layout/Row.js";
import "@gnist/themes/tokens.css.js";
import "react-content-loader";
import { forwardRef } from "react";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import "../../../foundation/typography/index.js";
import classNames from "classnames";
import "../../../foundation/logos/Logo.css.js";
import { atoms } from "@gnist/themes/atoms.css.js";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { iconButtonOverlayRecipe } from "../shared-styles/iconButtonOverlay.css.js";
import { inputFieldWrapperRecipe, inputFieldStyle, inputContentWrapper, wrapperStyle } from "../shared-styles/inputField.css.js";
import { postInputWidth, preInputWidth, visibleLines } from "../shared-styles/inputFieldConstants.css.js";
import { labelStyle } from "../shared-styles/labelStyles.css.js";
import { prefixStyle, suffixStyle } from "../shared-styles/suffixPrefix.css.js";
import { useInputFieldLogic, getInputFieldProps, isClickableIcon } from "../shared.js";
import { wordCounterStyle } from "./textArea.css.js";
const TextArea = forwardRef(function TextArea2({ counterText, visibleLines: visibleLinesProp, ...props }, ref) {
  var _a, _b;
  const { wrapperProps, contentProps, commonInputProps } = useInputFieldLogic(props);
  const { inputProps } = getInputFieldProps(props);
  return jsxs("span", { ref, className: classNames(wrapperProps.className, wrapperStyle), children: [props.leadingIcon && isClickableIcon(props.leadingIcon) && jsx("button", { className: iconButtonOverlayRecipe({
    placement: "left",
    density: wrapperProps.density
  }), title: props.leadingIcon.title, onClick: props.leadingIcon.onClick }), jsxs("label", { htmlFor: props.id, className: inputFieldWrapperRecipe({
    disabled: props.disabled,
    density: props.density,
    validityType: (_a = props.validity) == null ? void 0 : _a.type,
    fieldType: "textArea"
  }), style: {
    ...assignInlineVars({
      [visibleLines]: (visibleLinesProp ?? 4).toString()
    })
  }, children: [jsx("textarea", { ...commonInputProps, ...inputProps, className: classNames(inputFieldStyle, inputProps.className), style: {
    ...assignInlineVars({
      [preInputWidth]: wrapperProps.preInputWidth,
      [postInputWidth]: wrapperProps.postInputWidth
    })
  }, onFocus: (event) => {
    var _a2, _b2;
    if ((_a2 = event.target.value) == null ? void 0 : _a2.length) {
      window.requestAnimationFrame(() => event.target.select());
    }
    (_b2 = inputProps.onFocus) == null ? void 0 : _b2.call(inputProps, event);
  } }), jsxs("span", { className: inputContentWrapper({ density: props.density }), children: [props.leadingIcon && jsx(Icon, { icon: isClickableIcon(props.leadingIcon) ? props.leadingIcon.icon : props.leadingIcon, className: atoms({ paddingRight: "xxs" }) }), props.prefix && jsx("span", { ref: contentProps.prefixRef, "aria-hidden": true, className: prefixStyle, children: props.prefix }), jsx("label", { id: contentProps.labelId, className: labelStyle({
    density: props.density,
    validityType: (_b = props.validity) == null ? void 0 : _b.type,
    isElevated: !!props.value,
    disabled: props.disabled
  }), style: {
    ...assignInlineVars({
      [preInputWidth]: wrapperProps.preInputWidth
    })
  }, children: jsx("span", { style: { position: "relative" }, children: props.label }) }), jsx("span", { style: { flexGrow: "1" } }), props.suffix && jsx("span", { ref: contentProps.suffixRef, "aria-hidden": true, className: suffixStyle, children: props.suffix }), props.trailingIcon && jsx(Icon, { icon: isClickableIcon(props.trailingIcon) ? props.trailingIcon.icon : props.trailingIcon, className: atoms({ paddingLeft: "xxs" }) })] }), counterText && jsx("span", { "aria-hidden": true, className: wordCounterStyle, children: counterText })] }), props.trailingIcon && isClickableIcon(props.trailingIcon) && jsx("button", { className: iconButtonOverlayRecipe({
    placement: "right",
    density: wrapperProps.density
  }), title: props.trailingIcon.title, onClick: props.trailingIcon.onClick, type: "button" }), jsx(InputHelperText, { id: contentProps.helperId, validity: props.validity, helperText: props.helperText, reserveSpaceForMessage: props.reserveSpaceForMessage, disabled: props.disabled })] });
});
const wordCount = (value, max) => `${value.trim().split(/\s/).filter((x) => !!x).length}/${max} words`;
const characterCount = (value, max) => `${value.trim().length}/${max}`;
export {
  TextArea,
  characterCount,
  wordCount
};
